<template>
  <div>
    <div class="container-fluid">
      <div class="page-header">
        <Breadcrumbs main="Home Page" title="Featured Slides" />
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5>Featured Slides</h5>
            </div>
            <div class="card-body">
              <div class="btn-popup pull-right">
                <b-button
                  @click="
                    showModal = true
                    selectedItem = {}
                  "
                  variant="primary"
                >
                  Add Slide
                </b-button>
              </div>
              <GlobalSlidesModal
                @formData="formData"
                @onCancel="onCancel"
                @onEdit="onEdit"
                :showModal="showModal"
                :selectedItem="selectedItem"
                :isEdit="isEdit"
              />
              <div class="table-responsive datatable-vue product-physical">
                <b-modal id="modal-2" title="Confirmation" @ok="deleteItem">
                  <p class="my-4">Are you sure!</p>
                </b-modal>
                <b-table
                  :select-mode="selectMode"
                  class="text-center"
                  striped
                  head-variant="light"
                  bordered
                  show-empty
                  stacked="md"
                  :items="items?.data"
                  :fields="tablefields"
                  :filter="filter"
                  :current-page="currentPage"
                  @filtered="onFiltered"
                >
                  <template #cell(image_url)="field">
                    <img
                      height="150px"
                      :src="field.item.image_url"
                      alt=""
                      width="150px"
                    />
                  </template>
                  <template #cell(actions)="{ item }">
                    <feather
                      type="edit-2"
                      stroke="#3758FD"
                      stroke-width="1"
                      size="18px"
                      fill="#3758FD"
                      stroke-linejoin="round"
                      @click="
                        showModal = true
                        selectedItem = item
                        isEdit = true
                      "
                    >
                    </feather>
                    <feather
                      type="trash"
                      v-b-modal.modal-2
                      @click="selectedItem = item"
                      stroke="#F72E9F"
                      size="18px"
                      fill="#F72E9F"
                    >
                    </feather>
                  </template>
                </b-table>
              </div>
              <b-col md="12" class="my-1 pagination-justify p-0">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="items?.totalRows"
                  :per-page="perPage"
                  aria-controls="my-table"
                  class="mt-4"
                ></b-pagination>
              </b-col>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import statusIcon from '../../components/featherIcons/status-icon.vue'
import GlobalSlidesModal from '../../components/modals/globalSlidesModal.vue'

export default {
  components: { statusIcon, GlobalSlidesModal },
  data() {
    return {
      tablefields: [
        { key: 'image_url', label: 'Image', sortable: false },
        { key: 'title', label: 'Title', sortable: false },
        { key: 'sub_title', label: 'Sub Title', sortable: false },
        { key: 'action_text', label: 'Action Text', sortable: false },
        { key: 'action_url', label: 'Action Url', sortable: false },
        { key: 'actions' }
      ],
      selectMode: 'single',
      filter: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      add: false,
      save: false,
      edit: null,
      item: '',
      selectedSku: '',
      index: null,
      showModal: false,
      isEdit: false,
      selectedItem: {}
    }
  },
  created() {
    this.$store.dispatch('slides/getFeaturedSlides', {
      page: this.currentPage,
      limit: this.perPage
    })
  },
  computed: {
    ...mapGetters({
      items: 'slides/getFeaturedSlides'
    }),
    sortOptions() {
      // Create an options list from our fields
      return this.tablefields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key }
        })
    }
  },
  watch: {
    currentPage(newPage) {
      this.$store.dispatch('slides/getFeaturedSlides', {
        page: newPage,
        limit: this.perPage
      })
    }
  },
  methods: {
    onCancel() {
      this.showModal = false
      this.isEdit = false
    },
    async formData(slideData) {
      const result = await this.$store.dispatch(
        'slides/createFeaturedSlide',
        slideData
      )
      if (result.status === 200) {
        this.showModal = false
        this.$store.dispatch('slides/getFeaturedSlides', {
          page: this.currentPage,
          limit: this.perPage
        })
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    async onEdit(slideData) {
      const result = await this.$store.dispatch(
        'slides/updateFeaturedSlide',
        slideData
      )
      if (result.status === 200) {
        this.showModal = false
        this.isEdit = false
        this.$store.dispatch('slides/getFeaturedSlides', {
          page: this.currentPage,
          limit: this.perPage
        })
      }
    },
    async deleteItem() {
      const result = await this.$store.dispatch(
        'slides/deleteFeaturedSlide',
        this.selectedItem.id
      )
      this.selectedItem = {}
      if (result.status === 200)
        this.$store.dispatch('slides/getFeaturedSlides', {
          page: this.currentPage,
          limit: this.perPage
        })
    }
  }
}
</script>

<style lang="scss" scoped>
table.text-center * {
  text-align: center;
}
</style>
